import moment from "moment";
import { Column } from "react-table";
import { Licence } from "../models/Licence";
import { DataGrid } from "./common/DataGrid";
import { ActionItem } from "./GridActionButton";
import { Icon } from "semantic-ui-react";

interface Props {
  licences?: Licence[] | null;
  pageCount?: number;
  onPageInfoChange: (pageSize: number, pageIndex: number) => void;
  onRenewLicence: (id: string) => void;
  onCancelAutoRenewal: (id: string) => void;
}

const LicencesGrid = ({ licences, pageCount, onPageInfoChange, onRenewLicence, onCancelAutoRenewal }: Props) => {
  const actionItems = [
    {
      key: "changeProduct",
      content: "Renew manually",
      callback: (id: string) => onRenewLicence(id),
    },
    {
      key: "cancelLicenceAutoRenewal",
      content: "Cancel auto renewal",
      callback: (id: string) => onCancelAutoRenewal(id),
    },
  ] as ActionItem[];

  const columns: Column<Licence>[] = [
    {
      Header: "Type",
      id: "type",
      accessor: (l) => l.type,
    },
    {
      Header: "Product name",
      id: "productName",
      accessor: (l) => l.productName,
    },
    {
      Header: "Renewal date",
      id: "renewalDate",
      accessor: (l) => moment(l.endDate).format("L"),
    },
    {
      Header: "Number of users",
      id: "numberOfUsers",
      accessor: (l) => l.numberOfUsers,
    },
    {
      Header: "Available slots",
      id: "availableUserSlots",
      accessor: (l) => l.availableUserSlots,
    },
    {
      Header: "Status",
      id: "status",
      accessor: (l) => l.status,
    },
    {
      Header: "Auto renewal",
      id: "autoRenewal",
      accessor: (l) => (l.isAutoRenewalCancelled ? <Icon name="times" /> : <Icon name="check" />),
    },
  ];

  return (
    <>
      <DataGrid
        columns={columns}
        actionItems={actionItems}
        actionButtonColumn={columns[5]}
        data={licences ? licences : []}
        onPageInfoChange={onPageInfoChange}
        loading={false}
        pageCount={pageCount}
      />
    </>
  );
};

export default LicencesGrid;
